"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _lodash = require("lodash");

var _DefinitionList = require("./DefinitionList");

var _DefinitionList2 = _interopRequireDefault(_DefinitionList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableList = function (_React$Component) {
    _inherits(TableList, _React$Component);

    function TableList(props) {
        _classCallCheck(this, TableList);

        var _this = _possibleConstructorReturn(this, (TableList.__proto__ || Object.getPrototypeOf(TableList)).call(this, props));

        _this.updateDimensions = function () {
            _this.setState({ width: window.innerWidth });
        };

        _this.state = {
            width: undefined
        };
        return _this;
    }

    _createClass(TableList, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            window.addEventListener("resize", this.updateDimensions);
            this.updateDimensions();
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            window.removeEventListener("resize", this.updateDimensions);
        }
    }, {
        key: "renderAsList",
        value: function renderAsList() {
            var tableElements = _react2.default.Children.toArray(this.props.children);

            var headers = (0, _lodash.get)(tableElements[0], "props.children.props.children", []).reduce(function (headerArray, header) {
                return headerArray.concat(header.props.children);
            }, []);

            var items = (0, _lodash.get)(tableElements[1], "props.children", []).reduce(function (newItems, item) {
                return newItems.concat([[].concat(_toConsumableArray(item.props.children.reduce(function (newItem, property) {
                    return newItem.concat(property.props.children);
                }, [])))]);
            }, []);

            return _react2.default.createElement(_DefinitionList2.default, { headers: headers, items: items });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                type = _props.type,
                respondsAt = _props.respondsAt;

            if (type === "list" || type === "responsive" && this.state.width < respondsAt) {
                return this.renderAsList();
            }
            return _react2.default.createElement(
                "table",
                { style: { width: "100%" } },
                this.props.children
            );
        }
    }]);

    return TableList;
}(_react2.default.Component);

TableList.displayName = "TableList";

TableList.propTypes = {
    /** Controls the type of element rendered, one of "responsive", "list", "table" */
    type: _propTypes2.default.oneOf(["responsive", "list", "table"]),

    /** The pixel value to swap to a list from a table */
    respondsAt: _propTypes2.default.number,

    /** The TableList requires a single thead and tbody as direct chilren */
    children: function children(props, propName, componentName) {
        var tableElements = _react2.default.Children.toArray(props["children"]);
        if (!Array.isArray(tableElements) || tableElements.length !== 2) {
            return new Error("The TableList must contain a single thead and single tbody as direct children.");
        }
        if (tableElements[0].type !== "thead") {
            return new Error("The TableList must contain a thead as the first element");
        }
        if (tableElements[1].type !== "tbody") {
            return new Error("The TableList must contain a tbody as the first element");
        }
    }
};

TableList.defaultProps = {
    respondsAt: 600,
    type: "responsive"
};

exports.default = TableList;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/TableList/TableList.js
// module id = 989
// module chunks = 95715928098905 168707334958949